<template>
  <div>
    <div v-if="isPaymentRewardType">
      <disbursement-delivery-status
        :item="item"
      />
    </div>
    <div v-else>
      <p class="delivery-label">
        {{ deliveryLabel }}
        <delivery-status
          v-if="item.isDigital"
          :status="item.deliveryStatus"
        />
        <span
          v-if="item.isPhysical"
          class="physical-delivery-note"
        >
          {{ $t('redemption-history-physical-delivery-note') }}
        </span>
      </p>
    </div>
    <tc-v-btn
      v-if="showResendBtn && !chatBotEnabled"
      id="resend-btn"
      color="primary"
      outlined
      class="rounded"
      @click="$emit('resend-reward')"
    >
      {{ $t('redemption-history-launch-resend-dialog') }}
    </tc-v-btn>
  </div>
</template>

<script>
import { RedeemedItem } from '@/store/classes/redeemed-item'
import DeliveryStatus from '@/components/history/DeliveryStatus'
import DisbursementDeliveryStatus from '@/components/history/DisbursementDeliveryStatus'
import { SVP_ADA_CHATBOT_ENABLED } from '@/plugins/split/ActiveSplits'

export default {
  name: 'ItemSuccessful',
  components: {
    DisbursementDeliveryStatus,
    DeliveryStatus
  },
  props: {
    item: {
      type: RedeemedItem,
      required: true
    },
    isPaymentRewardType: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    showResendBtn () {
      return this.item.isDigital
    },
    deliveryLabel () {
      return this.item.isDigital
        ? this.$t('complete-digital-address-heading')
        : this.$t('complete-physical-address-heading')
    },
    chatBotEnabled () {
      return this.$isSplitEnabled(SVP_ADA_CHATBOT_ENABLED)
    }
  }
}
</script>

<style lang="scss" scoped>
#resend-btn {
  text-transform: initial;
  background: #fff;
}
.delivery-label {
  font-weight: bold;
}
.physical-delivery-note {
  font-weight: normal;
  display: block;
}
</style>
